import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ChannelordersService } from '../../services/channelorders.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

@Component({
	selector: 'app-channelreports',
	templateUrl: './channelreports.component.html',
	styleUrls: ['./channelreports.component.scss']
})
export class ChannelreportsComponent implements OnInit {
	color = 'blue';
	loading = false;

	filters = {
		datefrom: this.defaultFrom(),
		dateto:   new Date().toISOString().split('T')[0],
		channel:  '',
	};

	stats: any = null;
	trends: any[] = [];
	topProducts: any[] = [];
	brands: any[] = [];
	expandedBrands: Set<string> = new Set();

	topProductColumns = ['rank','stkcode','description','channel','total_qty','total_revenue','order_count'];

	constructor(
		private location: Location,
		private svc: ChannelordersService,
		private globalSearchService: GlobalSearchService
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void { this.load(); }

	load(): void {
		this.loading = true;
		const { datefrom, dateto, channel } = this.filters;

		this.svc.getStats(datefrom, dateto).subscribe({
			next: r => { this.stats = r; },
			error: () => {}
		});

		this.svc.getTrends(datefrom, dateto).subscribe({
			next: r => { this.trends = r.data || []; },
			error: () => {}
		});

		this.svc.getTopProducts({ datefrom, dateto, channel, limit: 20 }).subscribe({
			next: r => { this.topProducts = r.data || []; this.loading = false; },
			error: () => { this.loading = false; }
		});

		this.svc.getBrandBreakdown({ datefrom, dateto, channel }).subscribe({
			next: r => { this.brands = this.groupBrands(r.data || []); },
			error: () => {}
		});
	}

	getChannelStat(channel: string): any {
		if (!this.stats?.channel_stats) return { order_count: 0, revenue: 0 };
		return this.stats.channel_stats.find((s: any) => s.channel === channel) || { order_count: 0, revenue: 0 };
	}

	totalRevenue(): number {
		if (!this.stats?.channel_stats) return 0;
		return this.stats.channel_stats.reduce((s: number, r: any) => s + parseFloat(r.revenue || 0), 0);
	}

	channelShare(channel: string): number {
		const total = this.totalRevenue();
		if (!total) return 0;
		const rev = parseFloat(this.getChannelStat(channel).revenue || 0);
		return Math.round((rev / total) * 100);
	}

	toggleBrand(brand: string): void {
		this.expandedBrands.has(brand) ? this.expandedBrands.delete(brand) : this.expandedBrands.add(brand);
	}

	isBrandExpanded(brand: string): boolean { return this.expandedBrands.has(brand); }

	back(): void { this.location.back(); }

	private defaultFrom(): string {
		const d = new Date();
		d.setDate(d.getDate() - 30);
		return d.toISOString().split('T')[0];
	}

	private groupBrands(data: any[]): any[] {
		const map: Record<string, any> = {};
		for (const row of data) {
			const b = row.brand || 'Unknown';
			if (!map[b]) map[b] = { brand: b, channels: [], total_revenue: 0 };
			map[b].channels.push(row);
			map[b].total_revenue += parseFloat(row.revenue || 0);
		}
		return Object.values(map).sort((a, b) => b.total_revenue - a.total_revenue);
	}
}
